/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-console */
import PropTypes from 'prop-types';
import {
  React, useEffect, useState, useContext,
} from 'react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { useProject } from '../../../config/ProjectContext';
import SimpleAlert from '../../utils/SimpleAlert';
import CustomTextArea from '../../utils/CustomTextArea';
import { DEPLOY_TYPE_MARKET, validMarketRegex } from '../../../utils/constants';
import StagedDeploymentConfig from './StagedDeploymentConfig';
import SelectedObjectsToDeployContext from '../../../config/SelectedAssetsContext';



export default function MarketDeploy({
  setTargets, setType, values, setValues, market, setMarket, selectedMarkets, setSelectedMarkets, stagedDeployment, setStagedDeployment, onStagedConfigChange, onLoadingChange,
}) {
  //  alert data
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertHeader, setAlertHeader] = useState('');
  const [alertText, setAlertText] = useState('');

  const { project } = useProject();
  const { selectedObjectsToDeploy } = useContext(SelectedObjectsToDeployContext);

  // DATA RETRIEVAL __________________________
  async function loadType() {
    setType(DEPLOY_TYPE_MARKET);
  }

  // WEBPAGE______________________________

  // process CSV data
  function openAlert(header, text) {
    setAlertHeader(header);
    setAlertText(text);
    setAlertOpen(true);
  }

  useEffect(() => {
    if (selectedMarkets.length > 0) {
      setTargets(selectedMarkets);
    }
  }, [selectedMarkets]);

  useEffect(() => {
    loadType();
  }, [project]);

  const onChangeMarket = (event) => {
    // check if the new introduced character is a letter (or if it is empty)
    if (event.target.value.match(/[a-zA-Z]/) || event.target.value === '') {
      // if it is a character, convert it to uppercase
      setMarket(event.target.value.toUpperCase());
    }
    // Check with a regex if the value has a valid market format
    if (validMarketRegex.test(event.target.value.toUpperCase())) {
      setMarket('');
      // Check if the market is already selected
      if (selectedMarkets.includes(event.target.value.toUpperCase())) {
        openAlert('Error', 'Market already selected');
      } else {
        setSelectedMarkets([...selectedMarkets, event.target.value.toUpperCase()]);
      }
    }
  };

  return (
    <div className="bg-gray-50">
      <SimpleAlert open={alertOpen} setOpen={setAlertOpen} header={alertHeader} body={alertText} />
      <div className="bg-white rounded-xl">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-6">
          <div>
            <label className="block text-xl leading-5 text-gray-900 mb-4">Indicates a Market</label>
            <p className="text-sm leading-6 font-normal text-gray-600 mb-4">
              Please enter the 2 uppercase characters associated with the ISO code of the selected country. 
              Once you have introduced one market, you can introduce another.
            </p>
            <div className="space-y-2">
              <label className="block text-sm font-medium text-gray-700">Select Market</label>
              <input
                id="inputMarketSelection-marketDeployment"
                type="text"
                maxLength={2}
                value={market}
                onChange={onChangeMarket}
                className="w-32 px-4 py-3 bg-gray-100 border-0 rounded-md focus:bg-white focus:ring-2 focus:ring-blue-500 focus:outline-none"
                placeholder="US"
              />
              {market.length === 2 && !validMarketRegex.test(market) && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-3 py-2 rounded text-sm">
                  Market not valid following ISO-3166 alpha-2
                </div>
              )}
            </div>
          </div>
          
          <div>
            <div className="border-2 border-dashed border-blue-300 rounded-lg min-h-[198px] p-4">
              <h3 className="text-xl leading-5 text-blue-600 text-center mb-4">Selected Markets</h3>
              <div className="flex flex-wrap gap-2 px-2">
                {selectedMarkets.map((selectedMarket, selectedMarketId) => (
                  <div
                    key={`chipMarket${selectedMarketId}`}
                    className="inline-flex items-center bg-white text-gray-700 border border-blue-500 rounded-full px-3 py-1 text-sm"
                  >
                    {selectedMarket}
                    <button
                      onClick={() => setSelectedMarkets(selectedMarkets.filter((marketAux) => marketAux !== selectedMarket))}
                      className="ml-2 text-gray-500 hover:text-gray-700"
                    >
                      <XMarkIcon className="w-4 h-4" />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        
        <div className="flex justify-end py-6 px-6">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={stagedDeployment}
              onChange={(e) => setStagedDeployment(e.target.checked)}
              disabled={!selectedMarkets || selectedMarkets.length === 0}
              className="mr-2"
            />
            Staged Deployment
          </label>
        </div>

        <StagedDeploymentConfig
          isEnabled={stagedDeployment}
          deploymentType={DEPLOY_TYPE_MARKET}
          selectedMarkets={selectedMarkets}
          selectedObjectsToDeploy={selectedObjectsToDeploy}
          onConfigChange={onStagedConfigChange}
          isBundleDeployment={selectedObjectsToDeploy?.[0]?.type === 'bundle'}
          onLoadingChange={onLoadingChange}
        />

        <div className="flex flex-col items-center pb-6">
          <div className="w-full">
            <CustomTextArea
              screenId="inputDeploymentComments-marketDeployment"
              title="Deployment description"
              placeHolder="Comments (optional)"
              size={300}
              values={values}
              setValues={setValues}
              isComment
              rows={4}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

MarketDeploy.propTypes = {
  setTargets: PropTypes.func.isRequired,
  setType: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  values: PropTypes.object.isRequired,
  setValues: PropTypes.func.isRequired,
  market: PropTypes.string.isRequired,
  setMarket: PropTypes.func.isRequired,
  selectedMarkets: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSelectedMarkets: PropTypes.func.isRequired,
  stagedDeployment: PropTypes.bool.isRequired,
  setStagedDeployment: PropTypes.func.isRequired,
  onStagedConfigChange: PropTypes.func,
  onLoadingChange: PropTypes.func,
};

MarketDeploy.defaultProps = {
  onStagedConfigChange: () => {},
  onLoadingChange: () => {},
};
